import React from "react";

import { ProviderScheduleSkeleton } from "./ProviderScheduleSkeleton";

export const ProviderSchedulesSectionSkeleton: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="max-h-96 space-y-4 overflow-y-auto pr-2">
        {Array.from({ length: 2 }).map((_, index) => (
          <ProviderScheduleSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};
